import React from 'react';
import {Library} from '../../components/library/Library';
import {useDocumentTitle} from '../../hooks/useDocumentTitle';

export const LibraryPage: React.FC = () => {
    useDocumentTitle('Your Library');
    return (
        <div>
            <Library/>
        </div>
    );
};
